/**
 * Performs initial processing, shim insertion, and event registration prior to application initialization.
 */
import $ from "jquery";
import _ from "underscore";
import Booter from "app/Booter";
import Promise from "bluebird/js/browser/bluebird";
import BrowserUtils from "core/utils/BrowserUtils";
import session from "app/Session";
import isMobile from "core/is-mobile";
import esriShim from "app/esri-shim";
import messenger from "app/Messenger";
import logger from "app/Logger";
import modals from "core/views/modals";
import WindowView from "core/views/WindowView";
import app from "./App";

//import our base css here
//eventually it should accompany the views that use it, but some of this stuff is super general,
//supposedly
///general vendor stuff
import "jquery-ui/themes/base/all.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";
import "bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import "animate.css/animate.css";
import "context.js/context.bootstrap.css";
import "../../lib/styles/colorjar/style.css";
import "bootstrap-tokenfield/dist/css/bootstrap-tokenfield.css";
///basic layout stuff
import "../../styles/general/fonts.scss";
import "../../styles/general/General.css";
import "../../styles/general/responsive.scss";
import "../../styles/general/theme.scss";
import "../../styles/general/mobile-tabs.css";
import "../../styles/general/mobile.css";
import "../../styles/general/mobile-override.scss";

if (!window.Promise) {
  window.Promise = Promise;
}

$.browser = {};
(function () {
  $.browser.version = BrowserUtils.detectIE(window.navigator.userAgent);

  if ($.browser.version) {
    $.browser.msie = true;
  } else {
    $.browser.msie = false;
    $.browser.version = 0;
  }
})();

if (isMobile) {
  $("body").addClass("mobile-detected");
}

function onBoot() {
  $(".dropdown-toggle").dropdown();
  $("body").removeClass("not-booted").addClass("booted");
}

(function () {
  var boot = _.once(function (scenario) {
    window.$ = $; //expose jquery

    WindowView.events.on("expose", function () {
      app.enableScroll();
      app.showActions();
    });

    WindowView.events.on("obscure", function () {
      app.disableScroll();
      app.hideActions();
    });

    esriShim.init(function (err) {
      if (err) {
        modals.loading.hide();
        messenger.error(
          "An error occurred loading required files. Reload the page to try again."
        );
        return logger.error(err);
      }

      session.whenAuthenticated(function () {
        //let's not with the plugin thing right now

        /*session.whenAuthenticated(function () {
				 var collection = new PluginCollection([], {
				 context: booter.getBootContext()
				 });

				 if(session.isAdmin){
				 $('.admin-menu').fadeIn().removeClass('hidden');
				 };
				 var collection = new PluginCollection([], {
				 context: booter.getBootContext()
				 });
				 than server-side rendering it

				 collection.fetch().done(function () {
				 async.each(collection.models, function (model, cb) {
				 if (session.can(['access', 'administer'], {
				 Application: model.id
				 })) {

				 if (model.get('Status') == 'normal') {
				 booter.bootPlugin(model).fail(function (err) {
				 ErrorUtils.handleError(booter.getBootContext(), {
				 skipUser: true || s.include(err.message, 'Script error') || s.include(err.message, 'Load timeout')
				 }, err);
				 }).always(function () {
				 cb();
				 });
				 } else {
				 cb();
				 }
				 }
				 }, onBoot)
				 }).fail(ErrorUtils.apiHandler(booter.getBootContext(), {
				 activity: 'booting the application'
				 }));
				 });*/

        if (session.isAdmin()) {
          $(".admin-menu").fadeIn().removeClass("hidden");
        }

        if (window.Intercom) {
          window.Intercom("update", {
            app_id: "gwrahg7n",
            name: session.user.fullName(),
            email: session.user.get("EmailAddress"),
            created_at: Math.round(
              new Date(session.user.get("createdAt")).getTime() / 1000
            ),
            updated_at: Math.round(
              new Date(session.user.get("updatedAt")).getTime() / 1000
            ),
            user_id: session.user.get("id"),
            username: session.user.get("Username"),
          });
        }

        if (window._errs) {
          _errs.meta = {
            username: session.user.get("Username"),
          };
        }

        var booter = new Booter();
        booter.boot().done(onBoot);

        /*booter.on('plugin:loaded', function (slug) {
				 //App.messenger.info('Plugin loaded: ' + slug);
				 $('.' + slug).unbind('click').parent('li').removeClass('disabled');
				 });*/
      });
    });
  });

  //the script engine isn't getting out of this one.
  window.addEventListener("load", _.partial(boot, "load"));
  $.ready(_.partial(boot, "ready"));
  setTimeout(_.partial(boot, "timeout"), 1000);
})();



//////////////////
// WEBPACK FOOTER
// ./public/js/app/bootstrap.js
// module id = 514
// module chunks = 1